
export class TrainingCourseQuestionSectionResponse {
  status: string;
  actualScore: number;
  targetScore: number;

  public deserialize(input: any): this {
    this.status = input.status;
    this.actualScore = input.result;
    this.targetScore = input.targetScore;

    return this;
  }
};
